//mobile
export const SET_IS_MOBILE = 'SET_IS_MOBILE';

// spinner
export const SET_LOADING = 'SET_LOADING';
export const SET_PROGRESS = 'SET_PROGRESS';

// notifications
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';

// modal windows
export const SET_MODAL = 'SET_MODAL';
export const SET_ON_CLOSE_CALLBACK = 'SET_ON_CLOSE_CALLBACK';
export const SET_OPTIONS = 'SET_OPTIONS';

//confirm modal
export const UPDATE_CONFIRMATION_INFO = 'UPDATE_CONFIRMATION_INFO';
export const SET_IS_FADE_SHOWN = 'SET_IS_FADE_SHOWN';
export const SET_IS_CONFIRM_SHOWN = 'SET_IS_CONFIRM_SHOWN';

// login
export const CHANGE_LOGIN_FORM = "CHANGE_LOGIN_FORM";

// authentication
export const SET_LOGGED_IN = 'SET_LOGGED_IN';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_SCHOOL_INFO = 'SET_SCHOOL_INFO';
export const RESET_STATE = 'RESET_STATE';

// profile
export const SET_PROFILE_INFO = 'SET_PROFILE_INFO';
export const SET_PROFILE_AVATAR = 'SET_PROFILE_AVATAR';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const SET_PROFILE_NOTIFICATIONS_STATUS = 'SET_PROFILE_NOTIFICATIONS_STATUS';
export const SET_HEADING_AVATAR_LOADING = 'SET_HEADING_AVATAR_LOADING';

// children
export const SET_CHILDREN = 'SET_CHILDREN';
export const SET_CHILD_ID = 'SET_CHILD_ID';
export const SET_CHILD_INFO = 'SET_CHILD_INFO';
export const SET_CHILD_SCHEDULE_INFO = 'SET_CHILD_SCHEDULE_INFO';
export const SET_CHILD_INFO_FOR_EDIT = 'SET_CHILD_INFO_FOR_EDIT';
export const SET_CHILD_PHOTO = 'SET_CHILD_PHOTO';
export const RESET_CHILD_INFO_FOR_EDIT = 'RESET_CHILD_INFO_FOR_EDIT';

//activities
export const SET_ACTIVITIES_INFO = 'SET_ACTIVITIES_INFO';
export const SET_ACTIVITIES_CLASSES = 'SET_ACTIVITIES_CLASSES';
export const SET_ACTIVITIES_CAMPS = 'SET_ACTIVITIES_CAMPS';
export const SET_ACTIVITY_CAMP_PRICING = 'SET_ACTIVITY_CAMP_PRICING';
export const SET_ACTIVITIES_AFTERCARE_SESSIONS = 'SET_ACTIVITIES_AFTERCARE_SESSIONS';
export const SET_ACTIVITY_AFTERCARE_DAY = 'SET_ACTIVITY_AFTERCARE_DAY';
export const SET_ACTIVITY = 'SET_ACTIVITY';
export const SET_ACTIVITIES_CLASS_REQUIRED = 'SET_ACTIVITIES_CLASS_REQUIRED';
export const SET_ACTIVITIES_CAMP_REQUIRED = 'SET_ACTIVITIES_CAMP_REQUIRED';
export const SET_ACTIVITIES_AFTERCARE_REQUIRED = 'SET_ACTIVITIES_AFTERCARE_REQUIRED';
export const SET_ACTIVITIES_AFTERCARE_DROP_IN_FULL = 'SET_ACTIVITIES_AFTERCARE_DROP_IN_FULL';
export const SET_TEACHERS = 'SET_TEACHERS';
export const SET_PICK_UP = 'SET_PICK_UP';
export const SET_T_SHIRT_SIZES = 'SET_T_SHIRT_SIZES';
export const SET_ACTIVITY_EXTRAS = 'SET_ACTIVITY_EXTRAS';
export const SET_ACTIVITY_EXTRAS_CAMP = 'SET_ACTIVITY_EXTRAS_CAMP';
export const SET_ACTIVITY_EXTRAS_AFTERCARE = 'SET_ACTIVITY_EXTRAS_AFTERCARE';
export const SET_ACTIVITY_EXTRAS_AFTERCARE_WHICH_USES_BEFORE = 'SET_ACTIVITY_EXTRAS_AFTERCARE_WHICH_USES_BEFORE';
export const SET_ACTIVITY_CHILD_ROSTER_INFO = 'SET_ACTIVITY_CHILD_ROSTER_INFO';
export const SET_POLICIES = 'SET_POLICIES';
export const UPDATE_CUSTOM_FORM = 'UPDATE_CUSTOM_FORM'
export const CLEAN_ACTIVITY_FORMS = 'CLEAN_ACTIVITY_FORMS'
export const SET_ACTIVITIES_AFTERCARE_ROSTERS_FREE_DAYS = 'SET_ACTIVITIES_AFTERCARE_ROSTERS_FREE_DAYS';
export const SET_ACTIVITIES_AFTERCARE_WAITLIST_FREE_DAYS = 'SET_ACTIVITIES_AFTERCARE_WAITLIST_FREE_DAYS';

//page options
export const SET_PAGINATION = 'SET_PAGINATION';
export const REMOVE_PAGINATION = 'REMOVE_PAGINATION';
export const GO_TO_PAGE = 'GO_TO_PAGE';
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE';
export const SET_PAGE_NUMBER = 'SET_PAGE_NUMBER';
export const SET_LOCATIONS = 'SET_LOCATIONS';
export const UPDATE_FILTERS = 'UPDATE_FILTERS';
export const UPDATE_FILTERS_DROPDOWN = 'UPDATE_FILTERS_DROPDOWN' ;
export const RESET_FILTERS = 'RESET_FILTERS';
export const UPDATE_SEARCH = 'UPDATE_SEARCH';
export const UPDATE_SORTING = 'UPDATE_SORTING';
export const SET_MODAL_FILTERS = 'SET_MODAL_FILTERS';
export const RESET_MODAL_FILTERS = 'RESET_MODAL_FILTERS';

//shopping cart
export const SET_SHOPPING_CART = 'SET_SHOPPING_CART';
export const SET_SHOPPING_INDICATOR = 'SET_SHOPPING_INDICATOR';
export const SET_EXIST_CARD = 'SET_EXIST_CARD';
export const SET_PAYMENT = 'SET_PAYMENT';
export const SET_COUPON_CODE = 'SET_COUPON_CODE';
export const TOGGLE_FREE_ACTIVITY = 'TOGGLE_FREE_ACTIVITY';

//receipts
export const SET_RECEIPTS = 'SET_RECEIPTS';
export const SET_IS_NEW_PAYMENT_FLOW_FEATURE = 'SET_IS_NEW_PAYMENT_FLOW_FEATURE';
export const SET_PAYNOW_RECEIPTS_PAGINATION_PARAMS = 'SET_PAYNOW_RECEIPTS_PAGINATION_PARAMS';
export const SET_PAYNOW_TRANSACTION_PAGE_SIZE = 'SET_PAYNOW_TRANSACTION_PAGE_SIZE';

//calendar
export const SELECT_CHILD = 'SELECT_CHILD';
export const SELECT_CALENDAR_DATE = 'SELECT_CALENDAR_DATE';
export const SELECT_CALENDAR_MODE = 'SELECT_CALENDAR_MODE';
export const SET_CALENDAR_ACTIVITY_DATES = 'SET_CALENDAR_ACTIVITY_DATES';
export const TOGGLE_CALENDAR_DROPDOWN_CHILD = 'TOGGLE_CALENDAR_DROPDOWN_CHILD';

//custom Form
export const SET_CUSTOM_FORM = 'SET_CUSTOM_FORM';
export const SET_CUSTOM_FORM_ANSWER = 'SET_CUSTOM_FORM_ANSWER';
export const CLEAN_CUSTOM_FORM = 'CLEAN_CUSTOM_FORM';

//payment
export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS';
export const SET_CLIENT_SECRET = 'SET_CLIENT_SECRET';
export const SET_PAYMENT_PAYLOAD = 'SET_PAYMENT_PAYLOAD';
export const SET_IS_CLEANING_IN_PROGRESS = 'SET_IS_CLEANING_IN_PROGRESS';
export const SET_PAY_NOW_ACTIVITY_ID = 'SET_PAY_NOW_ACTIVITY_ID';
export const SET_INVOICE_DATA = 'SET_INVOICE_DATA';
export const SET_COUPONS = 'SET_COUPONS';
export const SET_PAY_NOW_ENROLLMENT_DATA = 'SET_PAY_NOW_ENROLLMENT_DATA';
export const SET_IS_PAYMENT_METHODS_LOADING = 'SET_IS_PAYMENT_METHODS_LOADING';


// WEBPACK FOOTER //
// ./src/store/mutationTypes.js